import React from "react";
import { Route, Switch } from "react-router-dom";
// import Dashboard from "./dashboard";
// import Calendar from "./calendar";
import ExtraPages from "./extraPages";
import asyncComponent from "../../util/asyncComponent";
// import Homes from "./homes";
// import Reserves from "./reserves";
// import Homepage from "./homepage";
// import Signup from "../../containers/SignUp2";
import { withRouter } from "react-router";


const Dashboard = React.lazy(() => import('./dashboard'));
const Homes = React.lazy(() => import('./homes'));
const Reserves = React.lazy(() => import('./reserves'));
const Homepage = React.lazy(() => import('./homepage'));
const Signup = React.lazy(() => import('../../containers/SignUp2'));
const Customize = React.lazy(() => import('../../containers/Customize'));
const ConnectSites = React.lazy(() => import('./homes/routes/HomesList/connectsites'));

const Routes = ({ match }) =>
  <Switch>
    <Route path={`${match.url}/dashboard`} component={Dashboard}/>
    {/*<Route path={`${match.url}/chart`} component={Chart}/>*/}
    <Route path={`${match.url}/map`} component={Map}/>
    {/*<Route path={`${match.url}/calendar`} component={Calendar}/>*/}
    <Route path={`${match.url}/homes`} component={Homes}/>
    <Route path={`${match.url}/reserves`} component={Reserves}/>
    <Route path={`${match.url}/homepage`} component={Homepage}/>
    <Route path={`${match.url}/signup`} component={Signup}/>
    <Route path={`${match.url}/customize`} component={Customize}/>
    <Route path={`${match.url}/connectsites`} component={ConnectSites}/>


    <Route path={`${match.url}/extra-pages`} component={ExtraPages}/>
    <Route component={asyncComponent(() => import("app/routes/extraPages/routes/404"))}/>
  </Switch>;


export default withRouter(Routes);
